<template>
	<div class="page">
		<van-nav-bar :title="navTitle" class="nav-bar" left-arrow @click-left="back">
			<template #left>
				<van-icon name="arrow-left" color="#c9a84c" size="22" />
			</template>
		</van-nav-bar>
		<div class="box" v-if="xuanfeidata && xuanfeidata.id">
			<p class="name">{{ xuanfeidata.xuanfei_name }}</p>
			<p class="title" v-if="subTitle">{{ subTitle }}</p>
			<img
				v-for="(v, k) in images"
				:key="k"
				class="pic"
				:src="v"
				:alt="xuanfeidata.xuanfei_name"
			/>
			<van-button round block class="button" color="#c9a84c" @click="yuyue">
				{{ $t("concubine.contactMe") }}
			</van-button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			xuanfeidata: {}
		};
	},
	computed: {
		navTitle() {
			return (this.xuanfeidata && this.xuanfeidata.xuanfei_name) || this.$t("concubine.concubine");
		},
		images() {
			const imgs = this.xuanfeidata && this.xuanfeidata.img_url;
			if (Array.isArray(imgs)) return imgs.filter(Boolean);
			if (typeof imgs === "string" && imgs) return [imgs];
			return [];
		},
		subTitle() {
			const d = this.xuanfeidata || {};
			return d.vo_title || d.address || d.service || d.jianjie || d.content || "";
		}
	},
	methods: {
		back() {
			this.$router.go(-1);
		},
		getxuanfeidata() {
			this.$http({
				method: "get",
				url: "xuanfeidata",
				data: { id: this.$route.query.id }
			}).then((res) => {
				this.xuanfeidata = (res && res.data) || {};
			});
		},
		yuyue() {
			this.$toast(this.$t("reservation.counselor"));
		}
	},
	created() {
		this.getxuanfeidata();
	}
};
</script>

<style lang="less" scoped>
.page {
	min-height: 100vh;
	background: #000000;
}
.nav-bar {
	background: #c9a84c !important;
}
::v-deep .van-nav-bar__title {
	color: #000;
}
.box {
	width: 95%;
	margin: 0 auto;
	text-align: center;
	padding: 16px 0 40px;
}
.name {
	margin: 8px 0 4px;
	font-size: 20px;
	font-weight: 600;
	color: #222;
}
.title {
	margin: 0 0 14px;
	font-size: 13px;
	color: #888;
}
.pic {
	width: 98%;
	display: block;
	margin: 0 auto 10px;
	border-radius: 8px;
	background: #141414;
	object-fit: contain;
}
.button {
	width: 70%;
	max-width: 280px;
	height: 44px;
	margin: 24px auto 0;
	font-size: 16px;
	font-weight: 600;
}
</style>
